import _ from "lodash";
import Box from "../components/box";
import Btn from "../components/btn";
import Input from "../components/input";
import Spinner from "../components/spinner";
import h from "../core/createElement";
import Modal from "../core/modalEngine";
import group_service from "../service/group_service";
import { next_input_chain, path_name_regex, switchable_element } from "../utils";
import popupAlerts from "../core/popupAlerts";
import report_service from "../service/report_service";



function CloneReport({ id, onInit, hide, got_to_cloned_one }) {
    const
        shared = {},
        fields_name = ['name', 'path_name'],
        loading = switchable_element(<Spinner />),
        select_group = switchable_element(<Input title="Aplicação de destino" type="select" />)

    const
        go_to_next_input = next_input_chain(shared),
        endpoint_preview = () => {
            const p = shared.path_name;
            if (p.value != "") p.subtitle(`${location.origin}/export/${p.value}`);
            else p.subtitle("");
        },
        key_valid_path_name = (evt) => {
            go_to_next_input("target_group_id")(evt);

            if (!path_name_regex.test(evt.key) && evt.key != "Backspace") {
                evt.preventDefault();
                popupAlerts.warning("O Endpoint pode pussuir apenas numeros, letras e traços (_ -) ");
                shared.path_name.invalid(true);
            };
        },
        handle_invalid_fields_by_request = (err) => {
            if (err.response && err.response?.data) {
                const data = err.response.data;

                if (data.messages) _.forEach(data.messages, msg => { shared[msg.field].invalid(true) });
            };
        },
        is_invalid_fields = () => {
            let error = false;

            for (let i of fields_name) {
                const input = shared[i];

                if (input.value == "" || input.value.length < 4 || input.value.length > 64) {
                    input.invalid(true);
                    error = true;
                };
            };

            if (!shared.target_group_id.value) {
                error = true;
                shared.target_group_id.invalid(true)
            };

            if (error) popupAlerts.warning("Preencha corretamente os campos!");

            return error;
        },
        get_targets_groups = async () => {
            try {
                loading.show();

                const { data } = await group_service.get_targets_groups_by_report_id(id);

                select_group.switch(
                    <Input
                        shared={shared}
                        type="select"
                        items={_.map(data.data, e => ({ label: e.name, value: e.id }))}
                        title="Aplicação de destino"
                        name="target_group_id"
                    />
                );
                loading.hide();
            } catch (e) {
                loading.hide();
                hide();
            };
        },
        do_clone_report = async () => {
            if (is_invalid_fields()) return;
            try {
                loading.show();

                const { name, path_name, target_group_id } = shared;

                const body = {
                    report_id: id,
                    name: name.value,
                    path_name: path_name.value,
                    target_group_id: +target_group_id.value
                };

                const { data } = await report_service.clone_report(body);

                hide(() => got_to_cloned_one && got_to_cloned_one(data.data));

                loading.hide();
            } catch (e) {
                handle_invalid_fields_by_request(e);
                loading.hide();
            };
        };

    onInit(() => {
        get_targets_groups();
    });

    return (
        <Box title={'Clonar relatório: ' + id} containerClass="min-w-450" buttons={<Btn icon="assets/image/x_white.svg" onClick={() => hide()} color="red" />}>
            <section class="full-size flex-column form-modal-content">
                <section class="flex-column flex-1">
                    <Input shared={shared} title="Nome" name="name" placeholder="Endpoint deve possuir entre 4 e 64 caracteres" onKeydown={go_to_next_input("path_name")} />
                    <Input shared={shared} title="Endpoint" name="path_name" placeholder="Endpoint deve possuir entre 4 e 64 caracteres" onKeyup={endpoint_preview} onKeydown={key_valid_path_name} />
                    {select_group.current()}

                    <section class="flex bottom-btns">
                        <Btn title="Salvar" color="green" name="save_btn" shared={shared} onClick={do_clone_report} />
                    </section>
                </section>
            </section>
            {loading.marker()}
        </Box>
    );
};


const CloneModalReport = new Modal(CloneReport);

export default CloneModalReport;